var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDownIcon2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.898 7.102C14.117 7.322 14.117 7.678 13.898 7.898L9.398 12.398C9.178 12.617 8.822 12.617 8.602 12.398L4.102 7.898C3.883 7.678 3.883 7.322 4.102 7.102C4.322 6.883 4.678 6.883 4.898 7.102L9 11.204L13.102 7.102C13.322 6.883 13.678 6.883 13.898 7.102Z",
    fill: "#030D45"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownIcon2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowDownIcon2.c1a9a602.svg";
export { ForwardRef as ReactComponent };